/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Site_Relation_Client_DescInputs */

const en_site_relation_client_desc = /** @type {(inputs: Site_Relation_Client_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A project for your client`)
};

const id_site_relation_client_desc = /** @type {(inputs: Site_Relation_Client_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proyek untuk klienmu`)
};

/**
* | output |
* | --- |
* | "A project for your client" |
*
* @param {Site_Relation_Client_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const site_relation_client_desc = /** @type {((inputs?: Site_Relation_Client_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Site_Relation_Client_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_site_relation_client_desc(inputs)
	return en_site_relation_client_desc(inputs)
});